var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeSong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12397_2369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6.8125C23.5 13.375 13.7697 18.6869 13.3553 18.9062C13.2461 18.965 13.124 18.9958 13 18.9958C12.876 18.9958 12.7539 18.965 12.6447 18.9062C12.2303 18.6869 2.5 13.375 2.5 6.8125C2.50174 5.27146 3.11468 3.79404 4.20436 2.70436C5.29404 1.61468 6.77146 1.00174 8.3125 1C10.2484 1 11.9434 1.8325 13 3.23969C14.0566 1.8325 15.7516 1 17.6875 1C19.2285 1.00174 20.706 1.61468 21.7956 2.70436C22.8853 3.79404 23.4983 5.27146 23.5 6.8125Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1214 18.4643L13.1184 18.4659C13.082 18.4855 13.0413 18.4958 13 18.4958C12.9587 18.4958 12.918 18.4855 12.8816 18.4659L12.8786 18.4644C12.6884 18.3636 10.1898 17.0017 7.74637 14.8619C5.27664 12.699 3.00014 9.85995 3 6.81277C3.00166 5.40425 3.56193 4.05389 4.55791 3.05791C5.55389 2.06193 6.90425 1.50166 8.31277 1.5C10.1025 1.50008 11.6446 2.26723 12.6002 3.5399L13 4.07243L13.3998 3.5399C14.3554 2.26723 15.8975 1.50008 17.6872 1.5C19.0957 1.50166 20.4461 2.06193 21.4421 3.05791C22.4381 4.05396 22.9984 5.40444 23 6.81306C22.9997 9.86014 20.7233 12.6991 18.2536 14.8619C15.8102 17.0017 13.3116 18.3636 13.1214 18.4643Z",
    stroke: "#BBC7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12397_2369",
    x: 0.5,
    y: 0,
    width: 25,
    height: 21.9958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12397_2369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12397_2369",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeSong);
export default __webpack_public_path__ + "static/media/like_song.9c72d9210d00f569f6c1e73dd62f30f4.svg";
export { ForwardRef as ReactComponent };